import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Modal, Popconfirm, Space, Table} from "antd";
import {CheckSquare, Edit2, Eye, Feather, Menu as MENU, Trash, X, Download, FileText} from "react-feather";
import SideMenuBar from "./components/SideMenuBar.jsx";
import toast from "../utils/swalToast";
import $ from "jquery";
import API_LINK from "../components/links/Link";
import {RiCheckDoubleFill} from "react-icons/ri";
import {BiCheckDouble} from "react-icons/bi";
import { exportToCSV, exportToPDF, formatAppointmentData } from "../utils/exportUtils";

export default function PastAppointments() {
    const history = useHistory();
    const [jobData, setJobData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [isExporting, setIsExporting] = useState(false);
    useEffect(() => {
        LoadAppointments();
    }, []);

    const LoadAppointments = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            if (localStorage.getItem("Role") == "User")
                formdata.append("page", "LoadMyPastAppointments");
            else formdata.append("page", "LoadPastAppointments");
            formdata.append("id", localStorage.getItem("UserId"));
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Appointment.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setJobData(result.data);
                            setFilterData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const handleSearch = (value) => {
        if (value) {
            const filtered = filterData.filter((item) => item.Name.toLowerCase().includes(value.trim().toLowerCase()) || item.Email.toLowerCase().includes(value.trim().toLowerCase()) || item.AppointmentDate.toLowerCase().includes(value.trim().toLowerCase()));
            setJobData(filtered);
        } else {
            setJobData(filterData);
        }

    };

    const handleExportCSV = () => {
        if (jobData.length === 0) {
            toast.warning("No data available to export");
            return;
        }
        setIsExporting(true);
        try {
            const formattedData = formatAppointmentData(jobData);
            exportToCSV(formattedData, `past_appointments_${new Date().toISOString().split('T')[0]}.csv`);
            toast.success("Past appointments exported to CSV successfully!");
        } catch (error) {
            toast.error("Failed to export data");
        } finally {
            setIsExporting(false);
        }
    };

    const handleExportPDF = () => {
        if (jobData.length === 0) {
            toast.warning("No data available to export");
            return;
        }
        setIsExporting(true);
        try {
            const formattedData = formatAppointmentData(jobData);
            exportToPDF(formattedData, `past_appointments_${new Date().toISOString().split('T')[0]}.pdf`);
            toast.success("Past appointments PDF report generated successfully!");
        } catch (error) {
            toast.error("Failed to generate PDF");
        } finally {
            setIsExporting(false);
        }
    };

    return (<>
            <div className='dashboard-container'>
                <SideMenuBar mobileShow={isMobileShow} onClose={() => setIsMobileShow(false)}/>
                <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <div className="page-header">
                        <div className="page-title-section">
                            <h2>Past Appointments</h2>
                            <span>View and export your completed appointments</span>
                        </div>
                        <div className="export-actions">
                            <button 
                                className="export-btn csv-btn" 
                                onClick={handleExportCSV}
                                disabled={isExporting}
                            >
                                <Download size={16} />
                                Export CSV
                            </button>
                            <button 
                                className="export-btn pdf-btn" 
                                onClick={handleExportPDF}
                                disabled={isExporting}
                            >
                                <FileText size={16} />
                                Export PDF
                            </button>
                        </div>
                    </div>
                    <div className="content-card">
                        <div className="table-search">
                            <input type="search" placeholder='Type to search...'
                                   onChange={(e) => handleSearch(e.target.value)}/>
                        </div>
                        <Table dataSource={jobData} pagination={{pageSize: pageSize,onChange: (n,count) => setPageSize(count)}}
                               loading={isLoading}
                               rowHoverable={true}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }}/>
                            <Table.Column title="Name" dataIndex="Name"/>
                            <Table.Column title="Email Address" dataIndex="Email"/>
                            <Table.Column title="Phone No." dataIndex="Phone"/>
                            <Table.Column title="Appointment Date" dataIndex="AppointmentDate"/>
                            <Table.Column title="Appointment Time" render={(j) => {
                                const time = JSON.parse(j.AppointmentTime);
                                return (<>
                                    <p>{time.day}</p>
                                    <p>{time.type}</p>
                                    <p>{time.hour}</p>
                                </>)
                            }}/>
                            <Table.Column title="Doctor Details" render={(j) => {
                                const doctor = JSON.parse(j.Doctor);
                                return (<>
                                    <img src={doctor.image} alt="Doctor Image"
                                         style={{width: 60, height: 60, borderRadius: 50}}/>
                                    <p>{doctor.name}</p>
                                    <a href={`mailto:${doctor.email}`} target={'_blank'}>{doctor.email}</a>
                                </>)
                            }}/>
                            <Table.Column title="Date" dataIndex="Date"/>
                            <Table.Column title="Status" dataIndex="Status"/>

                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
